import { render, staticRenderFns } from "./FLabel.vue?vue&type=template&id=75508466&"
import script from "./FLabel.vue?vue&type=script&lang=js&"
export * from "./FLabel.vue?vue&type=script&lang=js&"
import style0 from "./FLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports